//获取用户检测报告详情
const getExamDetailUrl = `/healthhubApi/exam/getExamDetail`;

// 查询 - 血压报告 - 详情
const getBloodPressReportDetailUrl = `/healthhubApi/bloodPressure/getBloodPressureById`;

export { getExamDetailUrl, getBloodPressReportDetailUrl };
